<template>
    <section class="legal-section">
        <div class="container">
            <h1 class="legal-title">Site Information</h1>

            <h2>Owner and Operator</h2>
            <p>
                Bader Harash<br>
                HarashFit – Personal Training<br>
                Amman, Jordan
            </p>

            <h2>Contact</h2>
            <p>
                Phone: +962 7 9060 6181<br>
                Email: info@harashfit.com<br>
                Website: <a href="https://www.harashfit.com" target="_blank">www.harashfit.com</a>
            </p>

            <h2>Content Responsibility</h2>
            <p>
                All content published on this website is provided by HarashFit unless otherwise stated. For any concerns regarding the content, please contact us directly using the information above.
            </p>

            <h2>Disclaimer</h2>
            <p>
                We strive to ensure that the content on this website is accurate and up-to-date. However, we make no warranties of any kind about the completeness or accuracy of the content. We are not responsible for the content of external websites linked from our site.
            </p>

            <h2>Online Dispute Resolution</h2>
            <p>
                If you are a resident in a country that provides online dispute resolution mechanisms, you may refer to your local consumer protection authority. The European Commission's ODR platform is available here:<br>
                <a href="https://ec.europa.eu/consumers/odr" target="_blank">https://ec.europa.eu/consumers/odr</a>
            </p>

            <p class="legal-footer">
                Last updated: May 2025
            </p>
        </div>
    </section>
</template>


<style scoped>
.legal-section {
    padding: 10px 20px;
    color: #f0f0f0;
    min-height: 100vh;
    line-height: 1.7;
    font-size: 15px;
}

.container {
    max-width: 900px;
    margin: auto;
}

.legal-title {
    font-size: 36px;
    font-weight: bold;
    color: #ffffff;
    margin-bottom: 20px;
    text-align: center;
}

h2 {
    margin-top: 32px;
    font-size: 22px;
    color: #ff5555;
}

p,
a {
    color: #cccccc;
    margin-bottom: 16px;
}

.legal-footer {
    margin-top: 40px;
    font-size: 14px;
    color: #aaa;
}
</style>